import { RouteElement } from '@components'

import { ReactElement } from 'react'
import { matchPath, useLocation } from 'react-router'

import { InvoiceEditor } from './InvoiceEditor'

interface InvoiceEditorRouteProps {
  paths: string[]
}

// Renders the editor for whichever of `paths` matches the current URL.
//
// Each of those paths is registered as its own discrete <Route> in ViewContainer.tsx, all pointing
// at this same component. The recurring invoice toggle navigates between them (e.g. from
// /invoices/:documentId/duplicate to /recurring-invoices/new); since every one of those Routes
// renders the exact same element type at the same tree position, React reconciles rather than
// remounts across the toggle - no extra machinery needed for that part.
//
// CompatRoute can't be used here: nested under a Route match, it needs a v5 RouterRoute inside to
// bridge to v5, which does its own separate match against the full pathname - it would never
// register a match against `matchedPath` here (see the docs on RouteElement/nested-CompatRoute).
// RouteElement bridges params from the *outer* Route's own already-correct v6 match instead - the
// matchPath/useLocation check below is only a safety net for the (never expected) case where
// `paths` doesn't actually match the current URL.
export const InvoiceEditorRoute = ({ paths }: InvoiceEditorRouteProps): ReactElement | null => {
  const { pathname } = useLocation()
  const matchedPath = paths.find((path) => matchPath(path, pathname))

  if (!matchedPath) {
    return null
  }

  return (
    <RouteElement>
      <InvoiceEditor />
    </RouteElement>
  )
}
